Property_tools = {
	init : function()
	{
		/* Property list gallery ---------------------------*/
	
		jQuery('.property-list .gallery a').each(function(){
			jQuery(this).click(function(){
				var $gallery = jQuery(this).attr('data-gallery');
				var $gallery_array = $gallery.split(',');
				var $gallery_list = new Array();
				
				for ($i = 0; $i < $gallery_array.length; $i++) {
					var $image = $gallery_array[$i];
					var $image_url = $image.replace(/'/g,'');
					var $image_obj = { 'src': $image_url, 'thumb': $image_url };
				    $gallery_list.push($image_obj);
				}
				
				jQuery(this).lightGallery({
					dynamic: true,
					dynamicEl: $gallery_list,
					thumbnail:true,
				})
			});
		});
	}
}

jQuery(document).ready(function(jQuery){
	
	Property_tools.init();
	
});